/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Redirect } from "react-router";
import { faRupeeSign } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, FormControl, Input, InputLabel } from "@material-ui/core";
import { CardBody, CardHeader, Col, Row } from "reactstrap";
import { toast } from "react-toastify";
import axios from "axios";
const coursename = {
  padding: "8px",
  textAlign: "center",
};
const imag = {
  width: "200px",
  height: "200px",
};
const headersection = {
  textAlign: "center",
  height: "80px",
  background: "#484799 0% 0% no-repeat padding-box",
  border: "3px solid #484799",
  opacity: 1,
};
const footersection={
  height: "80px",
  opacity: 1, 
  textAlign: "center", 
  lineHeight: "50px"
}
const Payment = (props) => {
  const [coursedata, setcoursedata] = useState([]);
  const [coursefeeid, setcoursefeeid] = useState(
    props?.location?.state?.coursefeeid
  );
  const [courseid, setcourseid] = useState(props?.location?.state?.courseid);
  const [user, setuser] = useState(props?.location?.state?.user);
  const [encRequest, setencRequest] = useState("");
  const [accessCode, setaccessCode] = useState("");
  // const [workingKey, setworkingKey] = useState("");
  const [btnvalue, setbtnvalue] = useState("Proceed");
  const [prmobtnvalue, setprmobtnvalue] = useState("Apply");
  const [disabled, setdisabled] = useState(true);
  const [promo, setpromocode] = useState("");
  const [checkcofflearn, setcheckcofflearn] = useState(false);
  const [values, setValues] = React.useState({
    totalfees: "",
    baseprice: "",
    gstcost: "",
    discountprice: "null",
    iscrspromo: "no",
    pcct: "null",
  });
  useEffect(() => {
    getorder();
    document.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });
    document.onkeydown = function (e) {
 
      // disable F12 key
      if(e.keyCode === 123) {
          return false;
      }

      // disable I key
      if(e.ctrlKey && e.shiftKey && e.keyCode === 73){
          return false;
      }

      // disable J key
      if(e.ctrlKey && e.shiftKey && e.keyCode === 74) {
          return false;
      }

      // disable U key
      if(e.ctrlKey && e.keyCode === 85) {
          return false;
      }
  } 
  // eslint-disable-line react-hooks/exhaustive-deps
  }, []);
  const getorder = async () => {
    let formData = new FormData();
    if (coursefeeid === undefined || courseid === undefined || user === null || user === undefined  ) {
      toast.error("Something went wrong!!", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      setcheckcofflearn(true);
      return;
    }
    formData.append("coursefeeid", coursefeeid);
    formData.append("courseid", courseid);
    formData.append("uid", user);
    axios
      .post("Payment/getorder", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          setcoursedata(res.data);
          setValues(() => ({
            totalfees: res.data.totalfees,
            gstcost: res.data.gstcost,
            baseprice: res.data.baseprice,
            discountprice: res?.data?.discount,
            iscrspromo: res?.data?.iscrspromo,
          }));
          console.log(values);
          if (res.data.message === "Already Register") {
            toast.warning("Already Register to this Course!!", {
              position: toast.POSITION.BOTTOM_LEFT,
            });
            setcheckcofflearn(true);
          }
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };
  const submitdetails = async () => {
    let formData = new FormData();
    formData.append("amount", values.totalfees);
    formData.append("coupon", values.pcct);
    formData.append("uid", user);
    formData.append("discount", values.discountprice);
    formData.append("courseoffid", coursedata.courseoffid);
    formData.append("crsfeeid", coursedata.crsfeeid);
    formData.append("order_id", coursedata.order_id);
    formData.append("tid", coursedata.tid);
    formData.append("merchant_id", coursedata.merchant_id);
    formData.append("currency", "INR");
    formData.append("redirect_url", coursedata.redirect_url);
    formData.append("cancel_url", coursedata.cancel_url);
    formData.append("billing_name", coursedata.bill_name);
    formData.append("billing_email", coursedata.bill_mail);
    formData.append("delivery_name", coursedata.del_name);
    formData.append("customer_identifier", coursedata.bill_mail);
    formData.append("utyp", coursedata.utype);
    formData.append("emiopt", "0");
    setbtnvalue("Processing...");
    setdisabled(false);
    axios
      .post("Payment/ccavRequestHandler", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          if(res.data.transactionstatus==="success")
          {
            localStorage.setItem("encordertoken", res.data.orderid);
            setencRequest(res.data.encRequest);
            setaccessCode(res.data.accessCode);
            document.redirect.submit();
          }
          else{
            setcheckcofflearn(true);
          }
          
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };
  const applypromocode = () => {
    if (promo.trim() === "" || promo.trim() === null) {
      toast.error("Enter valid Promocode", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    } else {
      let formData = new FormData();
      formData.append("coursefeeid", coursefeeid);
      formData.append("courseid", courseid);
      formData.append("uid", user);
      formData.append("promocode", promo.trim());
      setprmobtnvalue("Applying...");
      axios
        .post("Payment/applyPromocode", formData)
        .then((res) => {
          setprmobtnvalue("Apply");
          if (res.data.status === "200" || res.data.status === "100") {
            if (res.data.message === "Already Register") {
              toast.warning("Already Register to this Course!!", {
                position: toast.POSITION.BOTTOM_LEFT,
              });
              setcheckcofflearn(true);
            }
            if (res.data.success === "yes") {
              toast.success(res.data.message, {
                position: toast.POSITION.BOTTOM_LEFT,
              });

              console.log(values);
            } else {
              setpromocode("");
              toast.error(res.data.message, {
                position: toast.POSITION.BOTTOM_LEFT,
              });
            }
            setValues((currentValues) => ({
              totalfees: res.data.totalfees,
              gstcost: res.data.gstcost,
              baseprice: res.data.baseprice,
              discountprice: res?.data?.discount,
              iscrspromo: res?.data?.iscrspromo,
              pcct: res?.data?.pcct,
            }));
            return res;
          }
          throw res;
        })
        .catch((error) => {});
    }
  };
  if (checkcofflearn) {
    return <Redirect to="/Signin" />;
  }
  // if (!context.user?.email) {
  //   return <Redirect to="/" />
  // }
  return (
    <div>
      <div class="container-fluid blank-header" style={headersection}>
      <img src="/assets/images/logo.png" alt="whyepn1" />
      </div>
      <br />
      <br />
      <br />
      <section className="padding-default">
        <Row>
          <Col sm={12}>
            <Card>
              <CardHeader>{coursedata.coursename}</CardHeader>
              <CardBody>
                <div class="row">
                  <div class="col-lg-3">
                    <img
                      alt="img"
                      class="img-fluid img-responsive"
                      src={coursedata.logo}
                      style={imag}
                    />
                  </div>
                  <div class="col-lg-4">
                    <br />
                    <br />
                    <h4 style={coursename}>{coursedata.coursename}</h4>
                  </div>
                  <div class="col-lg-2"></div>
                  <div class="col-lg-3">
                    <br />
                    <h5>
                      Price : <br />
                      <FontAwesomeIcon icon={faRupeeSign} />{" "}
                      {coursedata.baseprice}
                    </h5>
                  </div>
                </div>
                <hr></hr>
                <div class="row">
                  <div class="col-lg-8"></div>
                  <div class="col-lg-4">
                    <>
                      <b>SubTotal</b>
                      <br />
                      {values.iscrspromo === "yes" ? (
                        <>
                          &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                          &nbsp;
                          <span
                            style={{
                              textDecorationLine: "line-through",
                              textDecorationStyle: "solid",
                            }}
                          >
                            <FontAwesomeIcon icon={faRupeeSign} /> &nbsp;
                            {values.baseprice} /-
                          </span>
                          <br />
                          &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;{" "}
                          <FontAwesomeIcon icon={faRupeeSign} />
                          &nbsp;{values.discountprice} /-
                        </>
                      ) : (
                        <>
                          {" "}
                          &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
                          &nbsp;&nbsp;&nbsp;
                          <FontAwesomeIcon icon={faRupeeSign} /> &nbsp;
                          {values.baseprice}
                        </>
                      )}
                      <br />
                      &nbsp; &nbsp; &nbsp;&nbsp; +&nbsp;&nbsp;{" "}
                      <FontAwesomeIcon icon={faRupeeSign} />
                      &nbsp;
                      {values.gstcost} /- ({coursedata.taxpercent} % GST)
                      <br />
                      <br />
                      <b>
                        Total :&nbsp;
                        <FontAwesomeIcon icon={faRupeeSign} />{" "}
                        {values.totalfees}/-
                      </b>
                      <br />
                      <button
                        onClick={submitdetails}
                        disabled={!disabled}
                        class="btn_1 rounded"
                      >
                        {btnvalue}
                      </button>
                      {coursedata?.ispromoapplicable === "yes" ? (
                        <div class="row px-3">
                          <div class="col-lg-8 ">
                            <FormControl style={{ width: "100%" }}>
                              <InputLabel htmlFor="standard-adornment-password">
                                Apply Promo Code
                              </InputLabel>
                              <Input
                                className="mb-4"
                                type="text"
                                name="PromoCode"
                                value={promo}
                                onChange={(e) => setpromocode(e.target.value)}
                                placeholder="Enter a valid Promo Code"
                              />
                            </FormControl>
                          </div>
                          <div class="col-lg-4 ">
                            <button
                              onClick={applypromocode}
                              disabled={!disabled}
                              class="btn_1 rounded"
                            >
                              {prmobtnvalue}
                            </button>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <form
          id="nonseamless"
          method="post"
          name="redirect"
          action="https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction"
        >
          <input
            type="hidden"
            id="encRequest"
            name="encRequest"
            value={encRequest}
          />
          <input
            type="hidden"
            name="access_code"
            id="access_code"
            value={accessCode}
          />
        </form>
      </section>
      <br />
      <br />
      <footer class="" style={footersection}>
      <strong> &copy; 2018-2021 edu plus now, All rights reserved.</strong>
    </footer>
    </div>
  );
};

export default Payment;
